export const replaceItemInArray = <T>(array: T[], itemIdentifier: (item: T) => boolean, newItemProvider: (oldItem: T) => T) => {
  return array.map(item => {
    if (itemIdentifier(item)) {
      return newItemProvider(item);
    }
    return item;
  });
}
